<template>  
    <div class="portfolio-row">
      <!-- Chart -->
      <div class="portfolio-row-item" style="width:120px;heigth:120px;">
        <sig-chart :values="portfolio.chart" color="#f8ce0b"
                   :barwidth="4" :barheight="2.2">
        </sig-chart>
        
        <span>
          <router-link :to="{ name: 'portfolio', params: { id: portfolio.id }}">{{portfolio.name}}</router-link>
        </span>
      </div>

      <!-- Rating -->
      <div class="portfolio-row-item portfolio-rating portfolio-bordered">
          <sig-stars :value="portfolio.rating * 100 / 5"></sig-stars>
          {{portfolio.rating.toFixed(2)}}
      </div>

      <!-- Specs -->
      <div class="portfolio-row-item portfolio-row-specs" style="heigth:120px;">
        <table class="table-portfolio-specs">
          <tr>
            <td>TWR</td><td>{{portfolio.twr.toFixed(2)}} %</td>
            <td>Profit</td><td>{{portfolio.profit.toFixed(2)}} {{portfolio.currency}}</td>
          </tr>
          <tr>
            <td>Drawdown</td><td>{{portfolio.drawdown.toFixed(2)}} %</td>
            <td>Term</td><td>{{portfolio.term}}, days</td>
          </tr>
        </table>
      </div>

      <!-- Profit gauge: profit -->
      <div class="portfolio-row-item portfolio-gauge portfolio-bordered">
          <sig-pie-gauge :value="profitGauge" :radius="50"
                          colorval="#a0ff90" colorscale="#f8ce0b">
          </sig-pie-gauge>
          profit: {{portfolio.rating.toFixed(2)}}
      </div>

      <!-- Profit gauge: drawdown -->
      <div class="portfolio-row-item portfolio-gauge">
          <sig-pie-gauge :value="riskGauge" :radius="50"
                          colorval="#ffa098" colorscale="#f8ce0b">
          </sig-pie-gauge>
          risk: {{portfolio.drawdown.toFixed(2)}}
      </div>

    </div>
</template>

<script>
  import SigStars from './sig-stars.vue';
  import SigChart from './sig-chart.vue';
  import SigPieGauge from './sig-piegauge.vue';
  export default {
      components: {
        'sig-stars': SigStars,
        'sig-chart': SigChart,
        'sig-pie-gauge': SigPieGauge
      },
      props: ['portfolio'],
      data() {
        return {          
        };
      },
      computed: {
        profitGauge() {
          return this.portfolio.rating * 100 / 5;
        },
        riskGauge() {
          return this.portfolio.drawdown;
        }
      },
      methods: {
      }
    };
</script>

<style scoped>
  div.portfolio-row {
    padding: 5px;
    margin: 5px;
    border-radius: 3px;
    text-align: left!important; 
  }

  .portfolio-row-item {
    vertical-align: middle;
    display:inline-block;
  }

  .portfolio-row-specs {
    width: 310px;
  }

  .portfolio-rating {
    width:120px;
    heigth:120px;    
    padding: 14px;
  }

  .portfolio-bordered {
    border-width: 0 1px 0 1px;
    border-color: #D0D0D0;
    border-style: solid;
  }

  .portfolio-gauge {
    heigth:120px;
    padding: 14px;
  }

  table.table-portfolio-specs td {
    padding-left: 8px;
  }
</style>